<template>
  <modal title="" width="45" :showModal="showModal" @close-modal="closeModal">
    <div class="table__search-input-wrapper w-[350px] filter-search">
      <span class="pr-2 opacity-50"><search-icon /> </span>

      <input type="text" class="table__search-input" placeholder="Search..." />
    </div>
    <div id="scroller">
    <div class="individual-contaoner">
      <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Shipping ID(s)</span></label>
      <el-select filterable v-model="shippingID" placeholder="All" @change="handleSelectChange('shippingID', $event)">
        <el-option v-for="booking in bookings" :key="booking.id" :label="booking.reference"
          :value="booking.reference">
        </el-option>
      </el-select>
    </div>

    <div class="individual-contaoner">
      <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Sender(s)</span></label>
      <el-select filterable v-model="sender" placeholder="All" @change="handleSelectChange('sender', $event)">
        <el-option v-for="booking in bookings" :key="booking.id"
          :label="booking.sender && booking.sender.contactName" :value="booking.sender && booking.sender.contactName">
        </el-option>
      </el-select>
    </div>

    <div class="individual-contaoner">
      <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Receiver(s)</span></label>
      <el-select filterable v-model="receiver" placeholder="All" @change="handleSelectChange('receiver', $event)">
        <el-option v-for="booking in bookings" :key="booking.id"
          :label="booking.receiver && booking.receiver.contactName" :value="booking.receiver && booking.receiver.contactName">
        </el-option>
      </el-select>
    </div>

    <div class="individual-contaoner">
      <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Shipping Service</span></label>
      <el-select filterable v-model="shippingService" placeholder="All" @change="handleSelectChange('shippingService', $event)">
        <el-option v-for="booking in bookings" :key="booking.id"
          :label="booking.shippingService.orgName && booking.shippingService.orgName" :value="booking.shippingService && booking.shippingService.orgName">
        </el-option>
      </el-select>
    </div>
    </div>
      <div class="flex items-center cursor-pointer mt-5">
      <div @click="apply">
        <primary-button buttonText="Apply" :loading="loading" :disabled="!canApply" />
      </div>
      <div>
        <p @click="closeModal()" class="pl-3">Cancel</p>
      </div>
    </div>
  </modal>
</template>

<script>
// import moment from "moment";

export default {
   props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    bookings: {
      required: true,
    },
    bookingData: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      selectedField: null,
      selectedValue: null,
      loading: false,
      shippingID: null,
      shippingService: null,
      sender: null,
      receiver: null,
      cycle: null,
    };
  },


  computed: {
    canApply() {
      if (this.selectedField === 'shippingID') return this.shippingID;
      if (this.selectedField === 'sender') return this.sender;
      if (this.selectedField === 'receiver') return this.receiver;
      if (this.selectedField === 'shippingService') return this.shippingService;
      return false;
    },

    receieverContactName() {
      return (booking) => {
        return (booking?.shipping?.shipmentReceiever || [])
          .map(item =>
            item?.location?.contactName ||
            item?.location?.name ||
            "N/A"
          )
          .join(", ");
      };
    }
  },

  methods: {

    closeModal() {
      this.$emit("close-modal");
    },

    handleSelectChange(field, value) {
      this.selectedField = field;
      this.selectedValue = value;
    },

    isDisabled(field) {
      // Disable all other select fields if one is selected
      return this.selectedField && this.selectedField !== field;
    },


    apply() {
      if (this.selectedField === 'shippingID') {

        this.$emit("appliedRef", this.shippingID);

      } else if (this.selectedField === 'sender') {

        this.$emit("appliedRef", this.sender);

      } else if (this.selectedField === 'receiver') {

        this.$emit("appliedRef", this.receiver);
      }
       else if (this.selectedField === 'shippingService') {

        this.$emit("filteredVal", this.shippingService);
      }     

      this.closeModal();
    },

  },
};
</script>

<style scoped lang="scss">
#scroller {
  max-height: 300px;
  overflow-y: auto;
}

.label {
  @apply border-b-2 border-gray-400 w-full pb-1;
  font-size: 13px;
}

.individual-contaoner {
  @apply w-full border-2 border-gray-300 border-dashed p-2 my-3
}

.filter-search {
  border-radius: 4px;
  @apply py-2
}
</style>

